import { render, staticRenderFns } from "./CalculateDetail.vue?vue&type=template&id=65eac7c3"
import script from "./CalculateDetail.vue?vue&type=script&lang=js"
export * from "./CalculateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports